import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import { ArrowRight } from "iconsax-react";
import { Form, Spinner } from "react-bootstrap";

import logo from "../../../image/authentication/authentication-logo.png";
import { loginRequestCodeApi } from "../../../utility/api/apiList";

import loginType from "../../../redux/actions/login/loginType";
import { showDangerAlert } from "../../../redux/actions/alert/alertActions";

import scrollToTop from "../../../libs/scrollToTop";

import TimerComponent from "../countDown";
import OTPComponent from "../OTP";
import ButtonComponent from "../button";

import {
  StyledForm,
  StyledAuthenticationSection,
  StyledContainer,
  StyledAuthenticationLogoWrapper,
  StyledAuthenticationLogo,
  StyledFormGroup,
  StyledBackButton,
} from "./loginStyled";

export default function LoginBySms({ props }) {
  //got code
  const [OTP, setOTP] = useState(new Array(5).fill(""));
  const [OTPError, setOTPError] = useState("");

  const dispatch = useDispatch();
  const loginDetail = useSelector((state) => state.loginDetail);
  useEffect(() => {
    document.title = "ورود";
    scrollToTop();
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();
    let prevPathPassed = "";
    if (props.location) {
      prevPathPassed = props.location.state.prevPath;
    } else {
      prevPathPassed = "/";
    }

    dispatch({
      type: "START_LOGIN",
      username: loginDetail.username,
      code: OTP.join(""),
      prevPath: prevPathPassed,
    });
  };

  useEffect(() => {
    if (loginDetail.error) {
      if (loginDetail.errorType === "password") {
        setOTPError(loginDetail.errorMessage);
      } else {
        dispatch(showDangerAlert(loginDetail.errorMessage));
      }
    }
  }, [loginDetail.error]);

  const handleGetCodeAgain = (e) => {
    let data = {
      phone: loginDetail.username,
    };
    axios
      .post(loginRequestCodeApi, data)
      .then(() => {
        dispatch({ type: loginType.SET_ERROR_FALSE });
        setOTPError("");
      })

      .catch(() => {
        dispatch(showDangerAlert("متاسفانه مشکلی پیش آمده"));
      });
  };

  const backToSelectLoginType = () => {
    dispatch({
      type: loginType.CHANGE_ACTIVE_STEP,
      payload: 1,
      username: "",
    });
  };

  return (
    <StyledAuthenticationSection>
      <StyledContainer $maxWidth="510px">
        <StyledForm
          noValidate
          autoComplete="off"
          className="px-sm-5"
          onSubmit={handleLogin}
        >
          <StyledAuthenticationLogoWrapper className="mx-auto">
            <StyledAuthenticationLogo src={logo} alt="azeto-logo" />
            <h1 className="h6 text-center">ورود</h1>
          </StyledAuthenticationLogoWrapper>
          <StyledFormGroup>
            <Form.Label htmlFor="password" className="d-block text-center">
              کد ارسال شده به شماره همراه
              <span className="text-primary"> {loginDetail.username}</span> را وارد
              کنید.
            </Form.Label>
            <OTPComponent
              setOTP={setOTP}
              OTP={OTP}
              errorMessage={OTPError}
            ></OTPComponent>
          </StyledFormGroup>

          <div className="text-center mt-4">
            <TimerComponent handleGetCodeAgain={handleGetCodeAgain} />
            {loginDetail.loading ? (
              <ButtonComponent className="px-5 mt-3 w-100" disabled>
                <Spinner
                  as="span"
                  animation="border"
                  role="status"
                  aria-hidden="true"
                ></Spinner>
              </ButtonComponent>
            ) : (
              <ButtonComponent
                type="submit"
                className="px-5 mt-5 w-100"
                disabled={OTP.includes("")}
              >
                ارسال
              </ButtonComponent>
            )}
          </div>
          <div className="text-center mt-5"></div>
        </StyledForm>
        <StyledBackButton
          onClick={() => {
            backToSelectLoginType();
          }}
        >
          <ArrowRight size="32" color="var(--dark-color)" variant="Outline" />
        </StyledBackButton>
      </StyledContainer>
    </StyledAuthenticationSection>
  );
}
